import { Module } from "vuex";
import { MutationsType, GettersType, ActionsType } from "@/utils/VuexHelper";
import { DashboardState } from "./types";
import { RootState } from "../../types";

import { getters, getterNames } from "./getters";
import { actions, actionNames } from "./actions";
import { mutations, mutationNames } from "./mutations";

const state = new DashboardState();

const namespaced: boolean = true;
const module: Module<DashboardState, RootState> = {
  namespaced,
  getters,
  actions,
  mutations,
  state,
};

export const api = {
  namespace: "dashboard",
  mutations: mutationNames,
  getters: getterNames,
  actions: actionNames,
};
export type Mutations = MutationsType<typeof mutations>;
export type Getters = GettersType<typeof getters>;
export type Actions = ActionsType<typeof actions>;

export default module;
